module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/facebook.svg?2ad0ed4c5d567c39f23077001feaac50";